export const TypeOfUser = {
    ADMIN: 'ADMIN',
    DISPATCHER: 'DISPATCHER'
};